"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Rendall API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.EscalationConfigToJSON = exports.EscalationConfigFromJSONTyped = exports.EscalationConfigFromJSON = exports.instanceOfEscalationConfig = exports.EscalationConfigTimeTypeEnum = void 0;
var runtime_1 = require("../runtime");
var ContactTimeRange_1 = require("./ContactTimeRange");
var EscalationTier_1 = require("./EscalationTier");
/**
 * @export
 */
exports.EscalationConfigTimeTypeEnum = {
    Any: 'any',
    DuringBusinessHours: 'during_business_hours',
    OutsideBusinessHours: 'outside_business_hours'
};
/**
 * Check if a given object implements the EscalationConfig interface.
 */
function instanceOfEscalationConfig(value) {
    var isInstance = true;
    isInstance = isInstance && "type" in value;
    isInstance = isInstance && "displayName" in value;
    isInstance = isInstance && "doNotEscalate" in value;
    isInstance = isInstance && "timeType" in value;
    isInstance = isInstance && "tiers" in value;
    return isInstance;
}
exports.instanceOfEscalationConfig = instanceOfEscalationConfig;
function EscalationConfigFromJSON(json) {
    return EscalationConfigFromJSONTyped(json, false);
}
exports.EscalationConfigFromJSON = EscalationConfigFromJSON;
function EscalationConfigFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'id': !(0, runtime_1.exists)(json, 'id') ? undefined : json['id'],
        'type': json['type'],
        'displayName': json['displayName'],
        'category': !(0, runtime_1.exists)(json, 'category') ? undefined : json['category'],
        'sitesToNotifyFor': !(0, runtime_1.exists)(json, 'sitesToNotifyFor') ? undefined : json['sitesToNotifyFor'],
        'usersToNotifyFor': !(0, runtime_1.exists)(json, 'usersToNotifyFor') ? undefined : json['usersToNotifyFor'],
        'devicesToNotifyFor': !(0, runtime_1.exists)(json, 'devicesToNotifyFor') ? undefined : json['devicesToNotifyFor'],
        'doNotEscalate': json['doNotEscalate'],
        'created': !(0, runtime_1.exists)(json, 'created') ? undefined : (new Date(json['created'])),
        'updated': !(0, runtime_1.exists)(json, 'updated') ? undefined : (new Date(json['updated'])),
        'timeType': json['timeType'],
        'timeRange': !(0, runtime_1.exists)(json, 'timeRange') ? undefined : (json['timeRange'].map(ContactTimeRange_1.ContactTimeRangeFromJSON)),
        'timezone': !(0, runtime_1.exists)(json, 'timezone') ? undefined : json['timezone'],
        'tiers': (json['tiers'].map(EscalationTier_1.EscalationTierFromJSON)),
    };
}
exports.EscalationConfigFromJSONTyped = EscalationConfigFromJSONTyped;
function EscalationConfigToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'id': value.id,
        'type': value.type,
        'displayName': value.displayName,
        'category': value.category,
        'sitesToNotifyFor': value.sitesToNotifyFor,
        'usersToNotifyFor': value.usersToNotifyFor,
        'devicesToNotifyFor': value.devicesToNotifyFor,
        'doNotEscalate': value.doNotEscalate,
        'created': value.created === undefined ? undefined : (value.created.toISOString()),
        'updated': value.updated === undefined ? undefined : (value.updated.toISOString()),
        'timeType': value.timeType,
        'timeRange': value.timeRange === undefined ? undefined : (value.timeRange.map(ContactTimeRange_1.ContactTimeRangeToJSON)),
        'timezone': value.timezone,
        'tiers': (value.tiers.map(EscalationTier_1.EscalationTierToJSON)),
    };
}
exports.EscalationConfigToJSON = EscalationConfigToJSON;
